//session stages
export const enum DataPointStages {
  beginning = 'beginning',
  middle = 'middle',
  end = 'end',
}

//session report display options
export const enum VitalStatsDisplayOptions {
  Table = 'Table',
  Graph = 'Graph',
}
